import React from 'react';
import moment from 'moment/moment';
import { Circle } from '@mui/icons-material';
import { Stack, Typography } from '@mui/material';

import { ParticipantInfo } from './ParticipantInfo';
import { DateFormats } from '../../../../../constants/common';
import { DealActivityParticipant } from '../../../api/types';

interface Props {
  actionName: string;
  actionDateTime: string | null;
  participants: DealActivityParticipant[];
}

export const FromToInfo = ({ participants, actionDateTime, actionName }: Props) => {
  const { internal, external } = participants.reduce<{
    internal: DealActivityParticipant | null;
    external: DealActivityParticipant[];
  }>(
    (acc, participant) => {
      if (participant.participationType === 'INTERNAL') {
        acc.internal = participant;
      } else {
        acc.external.push(participant);
      }

      return acc;
    },
    { internal: null, external: [] }
  );

  return (
    <Stack direction="row" gap="0.5rem" alignItems="center">
      <Typography color="textSecondary" component="span" variant="subtitle2">
        {actionName} From:
      </Typography>

      {internal && <ParticipantInfo name={internal?.fullName} />}

      {!!external.length &&
        external.map(participant => (
          <>
            <Typography color="textSecondary" component="span" variant="subtitle2">
              To:
            </Typography>

            <Circle color="disabled" sx={{ fontSize: 8 }} />

            <ParticipantInfo key={participant.id} name={participant.fullName} />
          </>
        ))}

      <Typography color="textSecondary" component="span" variant="subtitle2">
        {moment(actionDateTime).format(DateFormats.DateTimeMedium12Hour)}
      </Typography>
    </Stack>
  );
};
